import React from "react";

const MapComponentNew = ({
  latitude,
  longitude,
  title,
  subtitle,
}) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  const hasValidCoords =
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    Math.abs(lat) <= 90 &&
    Math.abs(lng) <= 180;

  if (!hasValidCoords) {
    return (
      <div className="flex items-center justify-center bg-[#F3F3F3] text-sm text-gray-600 rounded-2xl h-[360px] md:h-[420px] w-full">
        Location map unavailable
      </div>
    );
  }

  const query = `${lat},${lng}`;
  const embedSrc = `https://maps.google.com/maps?q=${encodeURIComponent(
    query
  )}&hl=en&z=14&output=embed`;
  const openMapsHref = `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
  const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    query
  )}`;

  return (
    <div className="relative w-full h-[360px] md:h-[420px] rounded-2xl overflow-hidden border border-[#E8E8E8] bg-[#EAEAEA]">
      <iframe
        title={title || "Property location"}
        src={embedSrc}
        className="absolute inset-0 w-full h-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <div className="absolute top-3 left-3 z-[2] max-w-[min(90%,320px)] bg-white rounded-xl shadow-md px-3 py-2.5 flex items-start gap-3">
        <div className="min-w-0">
          <div className="font-semibold text-[15px] text-[#222] truncate">
            {title || "Property location"}
          </div>
          {subtitle ? (
            <div className="text-[12px] text-[#717171] truncate mt-0.5">
              {subtitle}
            </div>
          ) : null}
        </div>
        <div className="flex items-center gap-1 shrink-0 pt-0.5">
          <a
            href={openMapsHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open in Google Maps"
            className="w-8 h-8 rounded-full hover:bg-[#F1F1F1] flex items-center justify-center text-[#444]"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M14 5h5v5M19 5l-7 7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </a>
          <a
            href={directionsHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get directions"
            className="w-8 h-8 rounded-full hover:bg-[#F1F1F1] flex items-center justify-center text-[#1A73E8]"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M21.71 11.29l-9-9a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l9 9a1 1 0 0 0 1.42 0l9-9a1 1 0 0 0 0-1.42ZM14 14.5V12h-4v3H8v-4a1 1 0 0 1 1-1h5V7.5l3.5 3.5L14 14.5Z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MapComponentNew;
